import React from 'react';
import { Copy, KeyRound } from 'lucide-react';
import { FormField } from '../../components/FormField';
import { FormRow } from '../../components/FormRow';
import { Button } from '../../../../ui/Button';
import { PropertyTypeSelector } from '../../components/PropertyTypeSelector';
import { LocationSelector } from '../../../../ui/LocationSelector';

interface PropertyInfoProps {
  formData: any;
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
  handleCopyAddress: () => void;
}

export const PropertyInfo: React.FC<PropertyInfoProps> = ({
  formData,
  handleInputChange,
  handleCopyAddress,
}) => {
  // Définir la date du jour par défaut
  const today = new Date().toISOString().split('T')[0];

  return (
    <div className="space-y-4">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4">
        Informations du bien
      </h3>

      <PropertyTypeSelector />

      <FormField label="Adresse">
        <div className="flex gap-2">
          <input
            type="text"
            name="propertyAddress"
            value={formData.propertyAddress}
            onChange={handleInputChange}
          />
          <Button
            variant="secondary"
            onClick={handleCopyAddress}
            title="Copier l'adresse du propriétaire"
            className="shrink-0"
          >
            <Copy className="h-4 w-4" />
          </Button>
        </div>
      </FormField>

      <LocationSelector
        wilayaName="propertyWilaya"
        wilayaValue={formData.propertyWilaya}
        communeName="propertyCity"
        communeValue={formData.propertyCity}
        onWilayaChange={handleInputChange}
        onCommuneChange={handleInputChange}
      />

      <FormField label="Référence de dosszier">
        <input
          type="text"
          name="reference"
          value={formData.reference}
          onChange={handleInputChange}
          placeholder="Référence du dossier"
        />
      </FormField>

      <FormField label="Date du dossier">
        <input
          type="date"
          name="fileDate"
          value={formData.fileDate || today}
          onChange={handleInputChange}
        />
      </FormField>

      {formData.transactionType === 'short-rent' && (
        <div className="flex items-center gap-3 p-4 bg-blue-50 dark:bg-blue-900/20 rounded-lg border border-blue-200 dark:border-blue-800">
          <KeyRound className="h-5 w-5 text-blue-600 dark:text-blue-400" />
          <label className="flex items-center gap-2 cursor-pointer">
            <input
              type="checkbox"
              name="is_concierge"
              checked={formData.is_concierge || false}
              onChange={handleInputChange}
              className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
            />
            <span className="text-sm font-medium text-gray-900 dark:text-white">
              Géré en conciergerie
            </span>
          </label>
        </div>
      )}
    </div>
  );
};